// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"styles_toolbar__c5zU0"};